import * as Config from "../../config";
import axios from "axios";
import Bugsnag from "@bugsnag/js";

const state = {
  userInfo: null,
  userInfoLoaded: false,
  access_token: null,
  userInitials: null
};

const actions = {
  login({ commit, dispatch }, data) {
    var postData = {
      client_id: 2,
      client_secret: Config.clientSecret,
      grant_type: "password",
      username: data.email,
      password: data.password,
      name: ""
    };

    return axios
      .post(Config.apiPath + "/oauth/token", postData)
      .then(response => {
        commit("setAccessToken", response.data);

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.data.access_token;

        return Promise.resolve();
      })
      .catch(error => {
        return error.response.status;
      })
      .then(
        // get user info
        dispatch("getUserInfo")
      );
  },

  getUserInfo({ commit }) {
    var header = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token")
      }
    };

    return axios.get(Config.apiPath + "/api/user", header).then(response => {
      if (Config.debugMode) console.log(response.data);

      commit("setUserInfo", response.data);

      return Promise.resolve(response);
    });
  },

  logout({ commit }) {
    localStorage.removeItem("access_token");
    commit("clearUserInfo");
  }
};

const mutations = {
  setAccessToken(state, data) {
    console.log("setting access_token");
    state.access_token = data.access_token;
    localStorage.setItem("access_token", data.access_token);
  },
  setUserInfo(state, data) {
    console.log(data);
    state.userInfo = data;
    state.userInfoLoaded = true;
    state.access_token = localStorage.getItem("access_token");
    state.userInitials = getInitials(data.name, " ");

    if (process.env.NODE_ENV === "production")
      Bugsnag.setUser(data.id, data.email, data.name);
  },
  clearUserInfo(state) {
    state.userInfo = null;
  }
};

const getters = {
  isAuthenticated: state => {
    return !!state.userInfo;
  },

  userInfo: state => {
    return state.userInfo;
  },

  userInitials: state => {
    return state.userInitials;
  },

  getAuthorizationHeader() {
    var header = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + state.access_token
      }
    };

    return header;
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};

function getInitials(name, delimeter) {
  if (name) {
    var array = name.split(delimeter);

    switch (array.length) {
      case 1:
        return array[0].charAt(0).toUpperCase();
        break;
      default:
        return (
          array[0].charAt(0).toUpperCase() +
          array[array.length - 1].charAt(0).toUpperCase()
        );
    }
  }
  return false;
}

// curl --request POST \
//   --header 'authorization: Bearer 8af91e1dbe75a34c53224a65d2ef911724dca3adec92670cb1cc04f5ebaea16e25672d2954b91e59' \
//   --header 'accept: application/json' \
//   --data '{"id":21695,"title":"3-12-22 Stanardsville, VA - Blizzard and Whiteout Snow Squalls","description":"Blizzard conditions continued intermittently on Saturday afternoon along the Blue Ridge Mountains in Central Virginia. Stanardsville saw downsloping winds which gusted above 50mph in heavy snow squalls, bringing brief whiteout conditions. The winds damaged many trees and brought power lines down along Route 33. #vawx #blizzard #snowstorm #virginia #snow","locations":["Virginia, USA"],"magicKeys":["dHA9MCNsb2M9MTc2Mzc1MSNsbmc9MzQjcGw9MzE2Njk0I2xicz0xNDo0MTE2MzY3MA=="],"locationsFromSearch":[{"text":"Virginia, USA","magicKey":"dHA9MCNsb2M9MTc2Mzc1MSNsbmc9MzQjcGw9MzE2Njk0I2xicz0xNDo0MTE2MzY3MA==","isCollection":false}],"tags":["Blizzard","Virginia","snow","snowstorm","whiteout"],"coordinates":[],"upload_id":"cec791d70c5afc7b5057ff054679c0c2","upload_filename":"cec791d70c5afc7b5057ff054679c0c2.MOV","status":"upload_complete","progress":"100.00","type":"eng","category":null,"breakdown":null,"droneVerification":false,"isDrone":false}' \
//   'https://api.cdn.livestormsvideo.com/api/v2/stringer/videos/upload/21695'
